import { render, staticRenderFns } from "./BaseAddress.vue?vue&type=template&id=384ee6fd&"
import script from "./BaseAddress.js?vue&type=script&lang=js&"
export * from "./BaseAddress.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports